import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, RefreshCw, Loader2 } from 'lucide-react';
import { useAdminSecurity } from './hooks/useAdminSecurity';
import { SecurityStatCards } from './security/SecurityStatCards';
import { FailedLoginsCard, GeoAnomaliesCard, ExportActivityCard, RecentActionsCard, IPWhitelistCard } from './security/SecurityAlertCards';
import { LockoutCard } from './security/LockoutCard';

const AdminSecurityDashboard = () => {
  const { dashboardData, adminRole, loading, error, lastUpdated, fetchDashboardData, formatTimestamp } = useAdminSecurity();

  if (loading) {
    return <div className="flex items-center justify-center p-12"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>;
  }

  if (error) {
    return <Alert variant="destructive"><AlertTriangle className="h-4 w-4" /><AlertDescription>{error}</AlertDescription></Alert>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white" data-testid="security-dashboard-heading">Security Dashboard</h2>
          <p className="text-sm text-gray-400">Last updated: {lastUpdated ? lastUpdated.toLocaleTimeString() : 'Never'}</p>
        </div>
        <Button onClick={fetchDashboardData} variant="outline" size="sm"><RefreshCw className="w-4 h-4 mr-2" />Refresh</Button>
      </div>
      <SecurityStatCards data={dashboardData} />
      <LockoutCard data={dashboardData?.lockouts} adminRole={adminRole} />
      <FailedLoginsCard data={dashboardData?.failed_logins} formatTimestamp={formatTimestamp} />
      <GeoAnomaliesCard anomalies={dashboardData?.geographic_anomalies} />
      <ExportActivityCard data={dashboardData?.export_activity} />
      <RecentActionsCard data={dashboardData?.recent_actions} />
      <IPWhitelistCard data={dashboardData?.ip_whitelist} />
    </div>
  );
};

export default AdminSecurityDashboard;
